import { Link } from 'react-scroll';
import styled from 'styled-components';
import { color, fontSize, spacing } from 'theme';

export const StyledAnchor = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: inherit;
  gap: ${spacing('xs2')};
  margin-top: ${spacing('xs')};
  font-size: ${fontSize('xs2')};
  line-height: 1;

  svg {
    color: ${color('midnight_300')};
  }
`;
